import * as React from 'react';
import { cn } from '../utils';

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, maxLength, ...props }, ref) => {
    const actualLength = props.value?.toString().trim().length || 0;
    const isTooLong = maxLength && actualLength > maxLength;

    return (
      <span className="relative size-full">
        <textarea
          className={cn(
            'border-border-soft text-primary placeholder:text-muted-foreground focus-visible:border-primary hover:border-primary flex min-h-[60px] w-full rounded-sm border-[1.5px] px-3 py-3 text-sm transition-colors duration-200 focus-visible:outline-hidden disabled:cursor-not-allowed disabled:opacity-50',
            className
          )}
          ref={ref}
          {...props}
        />
        {maxLength && (
          <span
            className={cn(
              'text-muted-foreground text-2xs absolute top-1 right-1 leading-3',
              {
                'text-destructive': isTooLong,
              }
            )}
          >
            {props.value?.toString().trim().length} / {maxLength || 1}
          </span>
        )}
      </span>
    );
  }
);
Textarea.displayName = 'Textarea';

export { Textarea };
